<template>
    <answers ref="answers"
             code_question_group="GQ21"
             danger_code="MCAL08"
             :unique_category="true"
             :show_next="showNext"
             :show_classification="showClassification"
             @ready="copyQuestions"
    >
        <template
            v-for="question in radio_questions"
            :slot="`answer_${question.value}_${question.code}`"
            slot-scope="data"
        >
            <b-form-radio
                v-model="data.data.answer"
                :class="`radio_${question.value}`"
                :value="question.bool_value"
                :state="question.bool_value"
                @change="question.on_change ? changeResponse(data.data) : null"
            >
                {{ question.label }}
            </b-form-radio>
        </template>
    </answers>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    },
    data() {
        return {
            copy_questions: [],
            radio_questions: [
                {
                    value: 'true',
                    code: 'QCAL194',
                    bool_value: true,
                    label: 'Positiva',
                    on_change: false
                },
                {
                    value: 'false',
                    code: 'QCAL194',
                    bool_value: false,
                    label: 'Negativa',
                    on_change: false
                },
                {
                    value: 'true',
                    code: 'QCAL195',
                    bool_value: true,
                    label: 'Polvo metálico',
                    on_change: true
                },
                {
                    value: 'false',
                    code: 'QCAL195',
                    bool_value: false,
                    label: 'Sustancia o mezcla distinta de polvo metálico',
                    on_change: true
                }
            ]
        }
    },
    computed: {
        ...mapState('calculator', [
            'question_groups',
            'questions_index'
        ]),
        showClassification() {
            let question_group = this.question_groups[this.questions_index];

            if (question_group) {
                let question = question_group.questions.find(q => q.code === 'QCAL194')
                if (question) {
                    return !question.answer
                }

                question = question_group.questions.find(q => q.code === 'QCAL195')

                if (question) {
                    return false
                }
            }

            return true;
        },
        showNext() {
            let question_group = this.question_groups[this.questions_index];

            if (question_group) {
                let question = question_group.questions.find(q => q.code === 'QCAL194')
                return question && question.answer;
            }

            return false;
        }
    },
    methods: {
        ...mapMutations('calculator', ['setQuestionGroupsWithAnswers']),
        copyQuestions() {
            this.copy_questions = JSON.parse(JSON.stringify(this.question_groups));
            this.initAnswers();
        },
        changeResponse(question) {
            let code = '';

            if (question.answer) { // Polvo metálico
                code = 'GQ3004';
            } else { // Sustancia o mezcla distinta de polvo metálico
                code = 'GQ3003';
            }

            let question_groups = JSON.parse(JSON.stringify(this.copy_questions.filter(q => q.code !== code)));

            question_groups.forEach(gq => {
                gq.questions.forEach(q => {
                    let questions = this.question_groups.flatMap(qg2 => qg2.questions);

                    let q2 = questions.find(q3 => q3.code === q.code);

                    if (q2) {
                        q.answer = q2.answer;
                    }
                })
            })

            this.setQuestionGroupsWithAnswers(question_groups);
        },
        initAnswers() {
            const all_questions = this.question_groups.flatMap(q => q.questions);

            let question = all_questions.find(q => q.code === 'QCAL195');

            if (question) {
                this.changeResponse(question);
            }
        }
    }
};
</script>
